import axios from '../utils/request';
// import {Message} from 'element-ui';

export const AjaxGet = (url, params, error) => {
    return new Promise((resolve, reject) => {
        axios.get(url,params).then(res => {
            resolve(res.data)
        }).catch(e => {
            e = error ? error : e
            console.log(e)
            reject(e)
        })
    })
}
export const AjaxPost = (url, data, error) => {
    return new Promise((resolve,reject) => {
        axios.post(url,data).then(res => {
            resolve(res.data)
        }).catch(e => {
            e = error ? error : e
            reject(e)
        })
    })
}